import PropTypes from 'prop-types';

export const PaymentMethodType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.oneOf([
    'RESURS_INVOICE',
    'RESURS_NEW_CARD',
    'PSP_CARD',
    'PSP_CREDIT_CARD',
    'PSP_DEBIT_CARD',
    'PSP_INTERNET',
    'RESURS_PART_PAYMENT',
    'RESURS_CARD',
    'PSP_SWISH',
    'PSP_DIRECT_BANK_TRANSFER'
  ]),
  valid: PropTypes.bool,
  name: PropTypes.string,
  fee: PropTypes.number,
  creditIntervals: PropTypes.arrayOf(PropTypes.number),
  cardNumber: null,
  index: 0,
  selected: false
});
